import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default {
  session: null,
  conversation: null,

  setCurrentSession(messaging_mode_session) {
    this.session = messaging_mode_session;
  },

  setCurrentConversation(conversation) {
    this.conversation = conversation;
  },

  messagesQueuedSinceManualMode(messagesByDate) {
    if (!this.isManualModeActive) {
      return [];
    }
    const queuedMessages = [];
    const since = this.session?.start_time.split(' ')[0];
    if (messagesByDate[since] !== undefined) {
      messagesByDate[since].forEach(date => {
        if (date.created_at.split(' ')[0] === since) {
          messagesByDate[since].forEach(message => {
            if (message.created_at >= since && message.status === 'queued') {
              queuedMessages.push(message);
            }
          })
        }
      })
    }
    return queuedMessages;
  },

  get isReplyWindowModeActive() {
    return this.session?.mode === 'ReplyWindow';
  },
  get isManualModeActive() {
    return this.session?.mode === 'Manual';
  },
  get isAutomatedModeActive() {
    return this.session?.mode === 'Automated';
  },
  get replyWindowModeExpiration() {
    if (this.session?.mode === 'ReplyWindow') {
      const datetime = this.session.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get manualModeExpiration() {
    if (this.session?.mode === 'Manual') {
      const datetime = this.session.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get sessionTimeRemaining() {
    if (this.session?.expires_at) {
      const datetime = this.session.expires_at;
      return dayjs(datetime).fromNow(true);
    }
  },
  get isConversationActive() {
    return !!this.conversation?.id;
  },
  get conversationExpiration() {
    if (this.conversation) {
      let datetime = this.conversation.expires_at;
      return dayjs(datetime).format('M/D/YYYY h:mm:ss A z');
    }
  },
  get conversationName() {
    if (this.conversation) {
      return this.conversation.source_name;
    }
  },
}
